<template>
  <div class="table_form">
    <div v-for="(it,x) in params.row.date_num" class="detail_row" :key="x">
      <el-form label-position="left" inline class="demo-table-expand">
        <el-form-item :label="t('生产日期')+'：'">
          <Input v-model="it.date" @on-blur="inputBlur('date', params, it)" :placeholder="t('请输入')"/>
        </el-form-item>
        <el-form-item :label="t('指定数量')+'：'">
          <Input v-model="it.num" @on-blur="inputBlur('num', params, it)" :placeholder="t('请输入')"/>
        </el-form-item>
      </el-form>
      <Button type="primary" icon="md-close" class="table_btn" @click="deleteRule(it, params.row)">{{t('删除')}}</Button>
    </div>
  </div>
</template>

<script>
import listeningToKeydownMixin from '@/assets/js/mixins/listeningToKeydown.js';

export default {
  mixins: [listeningToKeydownMixin],
  props: {
    params: {}
  },
  watch: {
    componentData: {
      handler(newVal) {
        this.request(newVal);
      },
      deep: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    inputBlur(a, b, c = it) {
      console.log('inputBlur::');
      this.$emit('dataChange', b)
    },
    deleteRule(it, row) {
      this.$emit('deleteRule', it, row)
    }
  },
  mounted() {
    console.log('------', this.params);
    // this.search(this.componentData);
  },
};

</script>

<style lang="less" scoped>
.table_form {
  .detail_row {
    display: flex;
    justify-content: flex-end;
  }
  .table_btn {
    position: relative;
    bottom: -8px;
    margin-left: 8px;
    margin-right: 16px;
  }
  /deep/.el-form-item {
    margin-right: 12px;
    margin-bottom: 0;
    width: max-content;

    .el-input,
    .el-form-item__label {
      font-size: 12px;
    }
  }
}
</style>
